import Header from './components/layout/Header'
import Sidebar from './components/layout/Sidebar'
import Footer from './components/layout/Footer'
import Sequencer from './components/sequencer/Sequencer'
import Mixer from './components/mixer/Mixer'
import EffectsPanel from './components/effects/EffectsPanel'
import './styles/tokens.css'

function App() {
  return (
    <div className="daw-container">
      <Header />
      <div className="daw-main">
        <Sidebar />
        <div className="daw-content">
          <Sequencer />
          <Mixer />
        </div>
        <EffectsPanel />
      </div>
      <Footer />
    </div>
  )
}

export default App
